import { EditOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import styled from 'styled-components';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { type IWidgetOptionDivider } from '../../../../Widget.ts';
import { WidgetOptionStructure } from './style/WidgetOptionStructure.tsx';

const GroupTitleCol = styled.div`
  width: 100%;
  border-radius: 4px;
  background-color: ${props => props.theme.colorBgLayout};
  padding: 2px 6px;
`;

export interface IWidgetOptionDividerViewProps {
  item: IWidgetOptionDivider;
  listeners?: any;
  onEdit?: (e: any) => void;
  onRemove?: (e: any) => void;
  onAdd?: (e: any) => void;
}

export function WidgetOptionDividerView(props: IWidgetOptionDividerViewProps) {
  const { item, listeners, onEdit, onRemove, onAdd } = props;

  return (
    <WidgetOptionStructure
      listeners={listeners}
      actions={
        <Space size={6} className="actions-buttons">
          {onRemove && (
            <Button
              size="small"
              icon={<MinusOutlined />}
              // disabled={props.disabled}
              onClick={e => onRemove(e)}
            />
          )}
          {onEdit && (
            <Button
              size="small"
              icon={<EditOutlined />}
              type="primary"
              onClick={e => onEdit(e)}
            />
          )}
          {onAdd && (
            <Button
              size="small"
              icon={<PlusOutlined aria-label="Aggiungi" />}
              // disabled={props.disabled}
              onClick={e => onAdd(e)}
            />
          )}
        </Space>
      }
    >
      <GroupTitleCol>
        <RichTextAdvancedRender inline text={item.label} />
      </GroupTitleCol>
    </WidgetOptionStructure>
  );
}
